import {
  SEND_EMAIL,
  SEND_EMAIL_SUCCESSFUL,
  SEND_EMAIL_FAILED
} from "./actionTypes"

const initialState = {
  message: null,
  loading: false,
}

const joinUs = (state = initialState, action) => {
  switch (action.type) {
    case SEND_EMAIL:
      return {
        ...state,
        data: null,
        loading: true,
      }

    case SEND_EMAIL_SUCCESSFUL:
      return {
        ...state,
        loading: false,
      }

    case SEND_EMAIL_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
      }

    default:
      return state
  }
}

export default joinUs
